module.exports = __webpack_public_path__ + "img/google_form.a17ecba0.svg";